<!-- 学校-课程评价统计 -->
<template>
  <div>
    <div class="index" v-show="!detail.show">
      <div class="title">
        <div class="span1">
          <span>{{$route.name}}</span>
        </div>
        <p style="color:#606266;font-size:14px;">截止日期: {{dayjs().format('YYYY-MM-DD')}}</p>
      </div>

      <!-- <header>
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>课程评价分布情况</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>自建课程好评率TOP5</span>
          </div>
           <p class="header-item-text">好评人数=评价四星人数+评价五星人数</p>
          <div id="echarts-box2"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>引入课程好评率TOP5</span>
          </div>
         
          <div id="echarts-box3"></div>
        </div>
      </header> -->

      <div>
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="">
            <el-select
              v-model="queryParams.semester"
              clearable
              placeholder="选择学年学期"
              class="label"
            >
              <el-option
                v-for="item in semesterList"
                :key="item.schooleYearName + 'xq'"
                :label="item.schooleYearName"
                :value="item.schooleYearName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="queryParams.source" placeholder="请输入课程来源"></el-input>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>

        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="cname" label="课程名称" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="source" label="课程来源" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="typeName" label="课程分类" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="rating" label="课程评价" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" label="操作" >
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="toDetail(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Detail
      :info="detail.info"
      v-show="detail.show"
      @to-index="toIndex"
      :semesterList="semesterList"
    ></Detail>
  </div>
</template>
<script>
import api from "@/api/schoolApi/index.js";
import dayjs from "dayjs";
import * as echarts from "echarts";
export default {
  components: {
    Detail: () => import("./detail.vue"),
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        semester: "",
        source: "",
        teacher: "",
        name: "",
      },
      semesterList: [],
      tableData: [],
      detail: {
        info: {},
        show: false,
      },
      school_info: JSON.parse(sessionStorage.getItem("classList")),
    };
  },
  watch: {

  },
  created() {
    this.campusList = this.school_info?.slice() || [];
    this.initData();
  },
  methods: {
    dayjs,
    async initData(){
      let params = { }
      // let res = await api.schoolStatisticalStar(params);
      let res1 = await api.schoolStatisticalSemester(params);
      if(res1.result==='000000'){
        this.semesterList=res1.data || [];
      }
    },
    async getDataList() {
      let semester = this.semesterList.filter(e=>e.schooleYearName===this.queryParams.semester);
      let start = "", end = "";
      if(semester && semester.length){
        start = semester[0].startDay || '';
        end = semester[0].endDay || '';
      }
      
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        schoolYearSemester: this.queryParams.semester,
        startDay: start,
        endDay: end,
        orgName:this.queryParams.source,
      };
      let res = await api.schoolStatisticalOrgstar(params);
      if (res.result === "000000") {
        this.tableData = res.data.list;
        this.totalPage = res.data.total || 0;
      }
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    toDetail(item) {
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
    init(){
      let vm = this;
      this.$nextTick(() => {
        // 圆环图
        let chartDom1 = document.getElementById('echarts-box1');
        let myChart = echarts.init(chartDom1);
        let option = {
          legend: {
            // data: [],
            // orient: 'vertical',
            left: 'center',
            top: 'bottom',
            icon : 'circle',
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['38%', '50%'], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 0,
                borderColor: '#fff',
                borderWidth: 0,
              },
              label: {
                show: false,
                position: 'center',
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '16',
                  fontWeight: 'bold',
                },
              },
              labelLine: {
                show: false,
              },
              data: [
                { value: 60, name: '5星' },
                { value: 58, name: '4星及以上' },
                { value: 32, name: '3星及以上' },
                { value: 30, name: '2星及以上' },
                { value: 28, name: '1星及以上' },
              ],
            },
          ],
          // 圆环颜色
          color: ['#5BB0FF', '#51D6A6', '#EFD051', '#F27676', '#757FFD'],
        };
        myChart.setOption(option);

        // 柱状图
        let chartDom2 = document.getElementById('echarts-box2');
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['作业\n辅导', '作业\n辅导', '科技\n编程', '幸福\n劳动\n课', '作业\n辅导'],
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [93, 92, 88, 76, 60],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: '#5BB0FF' },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999"
                    }
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart2.setOption(option2);

        // 柱状图
        let chartDom3 = document.getElementById('echarts-box3');
        let myChart3 = echarts.init(chartDom3);
        let option3 = {
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['美学\n鉴赏\n课', '海滨\n少儿\n美术', '幸福\n劳动\n课', '世界\n百科\n课', '美学\n鉴赏\n课'],
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [98, 96, 92, 70, 60],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: '#51D6A6' },
                  ]),
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999"
                    }
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart3.setOption(option3);
      });
    },
  },
  mounted() {
    this.getDataList();
    // this.init();
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
header{
  width: 100%;
  height: 350px;
  display: flex;
  .header-item{
    width: 33%;
    .header-item-title{
      font-size: 18px;
      color: #333;
      display: flex;
      align-items: center;
      .circle{
        width: 8px;
        height: 8px;
        display: inline-block;
        background: #4991e1;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .header-item-text{
      font-size: 14px;
      color: #666;
      padding-left: 20px;
      margin-top: 5px;
    }
  }
  #echarts-box1{
    width:280px;
    height:280px;
  }
  #echarts-box2,#echarts-box3{
    width:300px;
    height:280px;
  }
  #echarts-box3{
    margin-top: 25px;
  }
}
</style>
